import GetImage from '../../components/getimage/Getimage';
import Tint from "../../utility/ImageTint/Tint";
import chatbotai from '../../assets/novaicon.gif'
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Hierarchy from "../../assets/hierarchy.png";
import { useLocation, useNavigate } from 'react-router-dom';
import { useAliveController } from "react-activation";
import menuBtn from "../../assets/menu.png";

const Maindashboard = ({manualToggleValue,setManualToggleValue,isChatbot,hideSidebar,showSidebar,setsearchchatbot,setChatbotLoaded,Display,showWidth,setIsManuallyToggled,AIChatbotLink,activeLink,sideBarDetails,userName,setIsOpenHelpModal,userid,colors,showLogoutConfirm}) => {
 const {clear } = useAliveController();

 const handleNavigation = (s) => {
    if(!userid) return
  const isSameLink = s.name === activeLink;
  const isReportsException =
   ( location.pathname.includes("dailywork") || location.pathname.includes("leaderboard") || location.pathname.includes("tasktiming") || location.pathname.includes("taskcoasting") || location.pathname.includes("dynamicreport")) &&
    activeLink === "Reports";

  const isSamePath = location.pathname === s.targetPage;

  if (isSameLink && !isReportsException) return;

  if (isSamePath) return;
setManualToggleValue(false)
  setChatbotLoaded(false)
  setsearchchatbot(null)
  clear();
  setIsManuallyToggled(false);
  requestAnimationFrame(() => {
    navigate(s.targetPage);
  });
};


 const navigate=useNavigate()
  const location=useLocation()
    return (
        <div>
            {
                isChatbot &&   <div
                    className="Dashboard_header"
                    style={{ background: colors?.bgcolor }}
                >
                    <div className="left_bar">
                      <img
  src={menuBtn}
  onClick={() => {
   

    if (showWidth === "100px") {
      showSidebar();
      setManualToggleValue(true)
    } else {
      hideSidebar();
      setManualToggleValue(false)
    }
  }}
/>

                    </div>
                      {/* <div className="logo"> */}
                        <img
                            src={`https://trackhr.hexbis.com/Assets/trackhricon.png`}
                            alt="TrackHr logo"
                            style={{ width: "42px" }}
                        />
                        {
                            showWidth !== "100px" && <span
                            style={{ color: "blue", fontSize: "25px", fontWeight: "400" }}
                            className="logoNamefirstpart"
                        >
                            Track
                            <span
                                className="logoNamelastpart"
                                style={{ fontWeight: "bold" }}
                            >
                                Hr
                            </span>
                        </span>
                        }
                        
                    {/* </div> */}
                    </div>
            }
            
   <div
   
                        className="Dashboard_sidebar"
                        style={{ width: showWidth }}
                        onMouseEnter={() => {

                            console.log(showWidth,"showwidth")
                            if (showWidth == "100px" && manualToggleValue == false) {
                                showSidebar();
                            }
                        }}
                        onMouseLeave={() => {
                            
                            if (showWidth != "100px" && manualToggleValue == false) {
                                hideSidebar();
                            }
                        }}
                    >
                        <div className="user_descdisplayBox">
                            <div
                                className="userBox"
                                style={{
                                    padding: Display !== 'none' ? "0px 10px" : "0px"
                                }}
                            >

                                <OverlayTrigger
                                    placement="right"
                                    overlay={
                                        Display === 'none' ? (
                                            <Tooltip id={`tooltip-userprofile`}>{"Profile"}</Tooltip>
                                        ) : (
                                            <></>
                                        )
                                    }
                                >
                                    <div className="user_img" onClick={()=>{
                                        setsearchchatbot(null)
                                        setChatbotLoaded(false)
                                    }}>
                                        <GetImage width={Display !== 'none' ? "60px" : "50px"} height={Display !== 'none' ? "60px" : "50px"} key={userid} imgID={userid} top={false}


                                        />
                                    </div>
                                </OverlayTrigger>

                                {
                                    Display !== 'none' ? <div className="user_descdisplay">
                                        <span>{userName}</span>
                                    </div> : null
                                }

                                {
                                    Display !== 'none' ? <div onClick={() => {
                                        navigate(`/hierarchy`)
                                    }}>
                                        <img style={{ width: "20px", filter: "brightness(0) invert(1)", cursor: "pointer" }} src={Hierarchy} />
                                    </div> : null
                                }

                            </div>
                        </div>
                        <div className="sidebar_listdash">
                            {
                                AIChatbotLink !== -1 && AIChatbotLink !== "-1" && AIChatbotLink !== null && AIChatbotLink !== undefined &&
                                <OverlayTrigger
                                    placement="right"
                                    overlay={
                                        Display == 'none' ? (
                                            <Tooltip id={`tooltip-nova`}><p className='isdash'>NOVA Chatbot</p><p className='isdash'>Online</p></Tooltip>
                                        ) : (
                                            <></>
                                        )
                                    }
                                ><div className="novaai" onClick={() => {
                                    if(!userid) return
if(location.pathname != "/novachatbot"){
setChatbotLoaded(false)
setManualToggleValue(false)
navigate(`/novachatbot`)
}
                                }}>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "4px" }}>
                                            <div>
                                                <img src={chatbotai} className=" img-fluid" style={{ width: "38px" }} />
                                            </div>
                                            {
                                                Display !== 'none' && <div style={{ display: "flex", flexDirection: "column", lineHeight: "16px", marginTop: "3px" }}>
                                                    <span className="novaaitext">NOVA Chatbot</span>
                                                    <span className="textonline">Online</span>
                                                </div>
                                            }

                                        </div>
                                    </div></OverlayTrigger>
                            }

                            {sideBarDetails.map((s, index) => {

                                return (
                                    <>
                                        {s.display == 1 && (
                                            <>
                                                {index != 0 &&
                                                    s.group !== sideBarDetails[index - 1].group ? (
                                                    <>
                                                        <h5
                                                            style={{
                                                                fontWeight: "500",
                                                                fontSize: "13px",
                                                                paddingLeft: Display !== 'none' && "30px",
                                                                color: "rgba(0,0,0,0.7)",
                                                                paddingTop: "10px",
                                                                borderTop: "1px solid rgba(0,0,0,0.1)",
                                                                width: "100%",
                                                                display: Display == 'none' && "flex",
                                                                justifyContent: Display == 'none' && "center",
                                                                alignContent: Display == 'none' && "center"
                                                            }}
                                                        >
                                                            {s.group}
                                                        </h5>
                                                    </>
                                                ) : null}

                                                {s.name == "Logout" || s.name == "Need Help?" ? (

                                                    <div
                                                        className={
                                                            "tileboxside" +
                                                            (Display !== 'none' ? " open" : "")
                                                        }
                                                        style={{
                                                            width: Display !== 'none' ? "250px" : "",
                                                            cursor:userid ?  "pointer" : "none"
                                                        }}
                                                        onClick={() => {
                                                            if (s.name == "Logout") {
                                                                showLogoutConfirm();
                                                            } else {
                                                                setIsOpenHelpModal(true);
                                                            }
                                                        }}
                                                    >
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={
                                                                Display === 'none' ? (
                                                                    <Tooltip id={`tooltip-${index}`}>{s.name}</Tooltip>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        >
                                                            <div className="icon">
                                                                <img
                                                                    src={s.icon}
                                                                    style={{
                                                                        filter:
                                                                            s.name == activeLink
                                                                                ? Tint(colors?.Primary)
                                                                                : Tint("#333333"),
                                                                    }}
                                                                />
                                                            </div>
                                                        </OverlayTrigger>
                                                        {
                                                            Display != "none" && <div className="descdisplay"> <p className='isdash'>{s.name}</p>    <p className='isdash' style={{ padding: "10px" }}>
                                                                {s.count != 0 && s.count}
                                                            </p>  </div>
                                                        }
                                                    </div>

                                                ) :
                                                    <div

                                                        style={{ width: Display !== 'none' ? "250px" : "" , textDecoration:"none"}}
                                                        className={
                                                            "tileboxside" +
                                                            (Display !== 'none' ? " open" : "") +
                                                            (s.name == activeLink ? " activetile" : "")
                                                        }
                                                         onClick={() => {
handleNavigation(s)
      }}


                                                    >
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={
                                                                Display === 'none' ? (
                                                                    <Tooltip id={`tooltip-${index}`}>{s.name}</Tooltip>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        >
                                                            <div className="icon">
                                                                <img
                                                                    src={s.icon}
                                                                    style={{
                                                                        filter:
                                                                            s.name == activeLink
                                                                                ? Tint(colors?.Primary)
                                                                                : Tint("#333333"),
                                                                    }}
                                                                />
                                                            </div>
                                                        </OverlayTrigger>
                                                        {
                                                            Display !== "none" && <div className="descdisplay"> <p className='isdash'>{s.name}</p>    <p className='isdash' style={{ padding: "10px" }}>
                                                                {s.count !== 0 && s.count}
                                                            </p>  </div>
                                                        }
                                                    </div >
                                                }
                                            </>
                                        )}
                                    </>
                                );
                            })}
                        </div>
                    </div>
        </div>

  )
}
export default Maindashboard